import { createAction } from '@reduxjs/toolkit';
import { PlatformType } from '@/editor/shared/constants/available-platforms';
import { CreativeType } from '@/editor/shared/constants/creatives-types.enum';
import { type IPropertyInfoState } from '@/editor/store/reducers/property-info.slice';

export const hydrateFromLocalStorage = createAction<{
  adsetForm: any;
  activePlatforms: PlatformType[] | null;
  selectedCreativeType: CreativeType | null;
  creativeForms: Record<string, any> | null;
  propertyInfo: Partial<IPropertyInfoState> | null;
}>('store/hydrateFromLocalStorage');

export const refreshStateForNewAd = createAction('store/refreshStateForNewAd');
